const API_key = '54a26d24c0cf8baa9a15e144c3dcc4ed'
export default API_key